export const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (): void => resolve(reader.result as string)
        reader.onerror = (error): void => reject(error)
    })

const imageExtensions = [
    ".gif",
    ".jpg",
    ".jpeg",
    ".png",
    ".bmp",
    ".jpe",
    ".tif",
    ".tiff",
]
export const isImage = (path: string): boolean => {
    return imageExtensions.some((ext) => path.toLowerCase().endsWith(ext))
}
